var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.ui.contestTitle(_vm.contest)))]),
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.contest.start_time.long()))]),
            _c("span", [_vm._v("-")]),
            _c("span", [_vm._v(_vm._s(_vm.contest.finish_time.long()))])
          ]),
          _vm.isLoggedIn && !_vm.shouldShowModalToLoginWithRegisteredIdentity
            ? [
                _vm.now < _vm.contest.start_time.getTime()
                  ? _c(
                      "div",
                      [
                        _c("omegaup-countdown", {
                          attrs: {
                            "target-time": _vm.contest.start_time,
                            "countdown-format":
                              _vm.omegaup.CountdownFormat.ContestHasNotStarted
                          },
                          on: {
                            finish: function($event) {
                              _vm.now = Date.now()
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.now > _vm.contest.start_time.getTime()
                  ? _c("div", [
                      _vm.contest.admission_mode !== "registration" ||
                      _vm.contest.user_registration_accepted
                        ? _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.onStartContest($event)
                                }
                              }
                            },
                            [
                              !_vm.needsBasicInformation &&
                              _vm.requestsUserInformation === "no"
                                ? _c("p", [
                                    _vm._v(
                                      " " + _vm._s(_vm.T.aboutToStart) + " "
                                    )
                                  ])
                                : _vm._e(),
                              _vm.needsBasicInformation
                                ? _c("omegaup-markdown", {
                                    attrs: {
                                      markdown:
                                        _vm.T.contestBasicInformationNeeded
                                    }
                                  })
                                : _vm._e(),
                              _vm.needsBasicInformation
                                ? _c(
                                    "ul",
                                    {
                                      class: [
                                        "list-unstyled",
                                        "text-muted",
                                        "font-weight-light"
                                      ]
                                    },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.T.wordsCountry) +
                                            ": "
                                        ),
                                        _c(
                                          "span",
                                          { class: _vm.userInfoStatus.country },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.userBasicInformation
                                                    .country
                                                    ? "✔️"
                                                    : "❌"
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.T.profileState) +
                                            ": "
                                        ),
                                        _c(
                                          "span",
                                          { class: _vm.userInfoStatus.state },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.userBasicInformation.state
                                                    ? "✔️"
                                                    : "❌"
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("li", [
                                        _vm._v(
                                          " " + _vm._s(_vm.T.wordsSchool) + ": "
                                        ),
                                        _c(
                                          "span",
                                          { class: _vm.userInfoStatus.school },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.userBasicInformation
                                                    .school
                                                    ? "✔️"
                                                    : "❌"
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm.requestsUserInformation !== "no"
                                ? [
                                    _c("omegaup-markdown", {
                                      attrs: {
                                        markdown:
                                          (_vm.statement &&
                                            _vm.statement.markdown) ||
                                          ""
                                      }
                                    }),
                                    _c("p", [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.shareUserInformation,
                                              expression: "shareUserInformation"
                                            }
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.shareUserInformation,
                                              true
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.shareUserInformation = true
                                            }
                                          }
                                        }),
                                        _vm._v(
                                          " " + _vm._s(_vm.T.wordsYes) + " "
                                        )
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.shareUserInformation,
                                              expression: "shareUserInformation"
                                            }
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.shareUserInformation,
                                              false
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.shareUserInformation = false
                                            }
                                          }
                                        }),
                                        _vm._v(
                                          " " + _vm._s(_vm.T.wordsNo) + " "
                                        )
                                      ])
                                    ])
                                  ]
                                : _vm._e(),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    type: "submit",
                                    "data-start-contest": "",
                                    disabled: _vm.isButtonDisabled
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.T.startContest) + " ")]
                              )
                            ],
                            2
                          )
                        : _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.$emit(
                                    "request-access",
                                    _vm.contest.alias
                                  )
                                }
                              }
                            },
                            [
                              !_vm.contest.user_registration_requested
                                ? [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.T.mustRegisterToJoinContest)
                                      )
                                    ]),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-lg",
                                        attrs: { type: "submit" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.T.registerForContest) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                : !_vm.contest.user_registration_answered
                                ? _c("div", [
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.T.registrationPending))
                                    ])
                                  ])
                                : !_vm.contest.user_registration_accepted
                                ? _c("div", [
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.T.registrationDenied))
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.ui.formatString(
                                              _vm.T
                                                .registrationRejectionFeedback,
                                              {
                                                extra_note:
                                                  _vm.contest.extra_note
                                              }
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                    ])
                  : _vm._e()
              ]
            : _vm.shouldShowModalToLoginWithRegisteredIdentity
            ? [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.T.contestIntroLogoutToJoinWithRegisteredUser)
                      )
                    ]),
                    _c(
                      "a",
                      { staticClass: "card-link", attrs: { href: "/" } },
                      [_vm._v(_vm._s(_vm.T.contestIntroGoToHomePage))]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "card-link",
                        attrs: { href: _vm.logoutLink }
                      },
                      [_vm._v(_vm._s(_vm.T.contestIntroLogout))]
                    )
                  ])
                ])
              ]
            : [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("p", [_vm._v(_vm._s(_vm.T.mustLoginToJoinContest))]),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { href: _vm.redirectURL }
                      },
                      [_vm._v(_vm._s(_vm.T.loginHeader))]
                    )
                  ])
                ])
              ]
        ],
        2
      ),
      _c("hr"),
      _c(
        "div",
        [
          _c("h3", { staticClass: "ml-4" }, [
            _vm._v(_vm._s(_vm.T.registerForContestChallenges))
          ]),
          _c("omegaup-markdown", {
            attrs: { markdown: _vm.contest.description }
          })
        ],
        1
      ),
      _c("div", [
        _c("h3", { staticClass: "ml-4" }, [
          _vm._v(_vm._s(_vm.T.registerForContestRules))
        ]),
        _c("ul", [
          _vm.contest.show_scoreboard_after
            ? _c("li", [
                _vm._v(
                  " " + _vm._s(_vm.T.contestNewFormScoreboardAtContestEnd) + " "
                )
              ])
            : _vm._e(),
          _vm.contest.window_length !== null
            ? _c("li", [
                _vm._v(" " + _vm._s(_vm.differentStartsDescription) + " ")
              ])
            : _vm._e(),
          _vm.scoreboardDescription !== ""
            ? _c("li", [_vm._v(" " + _vm._s(_vm.scoreboardDescription) + " ")])
            : _vm._e(),
          _vm.contest.submissions_gap !== 0
            ? _c("li", [
                _vm._v(" " + _vm._s(_vm.submissionsGapDescription) + " ")
              ])
            : _vm._e(),
          _vm.contest.penalty_type !== "none"
            ? _c("li", [
                _vm._v(
                  " " + _vm._s(_vm.penaltyTypes[_vm.contest.penalty_type]) + " "
                )
              ])
            : _vm._e(),
          _vm.contest.penalty !== 0
            ? _c("li", [_vm._v(_vm._s(_vm.penaltyDescription))])
            : _vm._e(),
          _vm.contest.feedback !== "none"
            ? _c("li", [
                _vm._v(
                  " " + _vm._s(_vm.feedbackTypes[_vm.contest.feedback]) + " "
                )
              ])
            : _vm._e(),
          _vm.contest.points_decay_factor !== 0
            ? _c("li", [_vm._v(" " + _vm._s(_vm.pointsDecayDescription) + " ")])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }